/**
 * Làm tròn xuống luỹ thừa của 2 để các lượt chia đôi rơi đúng vào bước 1.
 */
function toPowerOfTwo(stride: number) {
  if (!Number.isFinite(stride) || stride < 2) return 1;
  return 2 ** Math.floor(Math.log2(Math.min(stride, 64)));
}

/**
 * Sinh thứ tự nạp lát xen kẽ cho một khối ảnh.
 *
 * Nạp tuần tự 0,1,2,... khiến khối đặc dần từ một đầu: kéo tới giữa ca là
 * vùng đen. Đi nhiều lượt với bước nhảy giảm dần thì ngay sau lượt đầu đã có
 * ảnh rải đều toàn khối, các lượt sau chỉ làm dày thêm.
 *
 * Lát mốc (mặc định là lát giữa - lát hiển thị đầu tiên) luôn được xếp trước
 * để không bị thứ tự xen kẽ đẩy xuống cuối hàng đợi.
 *
 * Ví dụ count=12, firstStride=8: 6, 0,8, 4, 2,10, 1,3,5,7,9,11
 *
 * @returns hoán vị của [0, count) - mọi lát đều có mặt đúng một lần
 */
export function interleavedLoadOrder(
  count: number,
  firstStride = 8,
  anchor = Math.floor(count / 2)
): number[] {
  if (!Number.isInteger(count) || count <= 0) return [];

  const order: number[] = [];
  const queued = new Uint8Array(count);

  const push = (i: number) => {
    if (queued[i]) return;
    queued[i] = 1;
    order.push(i);
  };

  if (Number.isInteger(anchor) && anchor >= 0 && anchor < count) push(anchor);

  for (let stride = toPowerOfTwo(firstStride); stride >= 1; stride >>= 1) {
    for (let i = 0; i < count; i += stride) push(i);
  }

  return order;
}
